import { ComponentType, forwardRef, memo, useState } from "react";
import { Input, InputProps } from "../Input";
import { EmailInput, EmailInputProps } from "./EmailInput";


export type EmailFieldProps = Omit<InputProps<EmailInputProps>, "onChange" | "value"> & {
  onChange?: (value: string[]) => void,
  value?: string[],
  hasError?: boolean,
  errorText?: string,
}

const EmailField = memo<EmailFieldProps>(forwardRef<any, EmailFieldProps>(({ onChange, value, hasError, errorText, ...props }, ref) => {
  const [ internalErrors, setInternalErrors ] = useState("");

  return <Input
    {...props}
    value={value || []}
    ref={ref}
    component={EmailInput}
    onChange={onChange as any}
    hasError={hasError || !!internalErrors}
    errorText={errorText || internalErrors}
    showErrorIcon={false}
    isClearable={false}
    setInternalErrors={setInternalErrors}
  />;
}));


(EmailField as ComponentType<EmailFieldProps>).defaultProps = {};

export default EmailField;
